import { TextCollectionField } from '@scale/shared/types/params/textcollection';
import FormFieldSection from './FormFieldSection';
import { ChatTaskBehaviorLogMetadata } from '@scale/shared/types/chat';
import { FormProvider, useForm } from 'react-hook-form';
import { fieldsToZodSchema } from './schema';
import { DocumentProvider } from 'react-scale/components/scalers/tasks/textcollection/document';
import { zodResolver } from '@hookform/resolvers/zod';

interface FormProps {
  title?: string;
  description?: string;
  fields: TextCollectionField[];
  readOnly: boolean;
  assignmentId?: string;
  chatTaskBehaviorLogMetadata?: ChatTaskBehaviorLogMetadata;
  setSubmitCodeError?: (field_id: string, error: string) => void;
  readOnlyMessage?: string;
  templateVariables?: Record<string, string>;
}

export default function Form({ fields, ...props }: FormProps) {
  const form = useForm({
    resolver: zodResolver(fieldsToZodSchema(fields)),
    mode: 'all',
  });

  //   const values = form.watch();

  //   const templateVariables = props.templateVariables ?? useTemplateVariableStore.getState();

  const fieldSections = fields.map(field => {
    return (
      <div key={field.field_id}>
        <FormFieldSection
          readOnly={props.readOnly}
          field={field}
          assignmentId={props.assignmentId}
          setSubmitCodeError={props.setSubmitCodeError}
          chatTaskBehaviorLogMetadata={props.chatTaskBehaviorLogMetadata}
          readOnlyMessage={props.readOnlyMessage}
        />
      </div>
    );
  });

  return (
    <DocumentProvider attachments={0} fields={fields}>
      <FormProvider {...form}>
        <div className="flex flex-col items-stretch w-full h-full bg-white">
          <div className="p-2">{fieldSections}</div>
        </div>
      </FormProvider>
    </DocumentProvider>
  );
}
